module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"draft":"Draft","published":"Active","publishedEdited":"Active - Unpublished edits","moreActions":{"rename":"Rename","delete":"Delete"},"createDate":"Created: {date}","publishDate":"Published: {date}"}}')
  delete Component.options._Ctor
}
